/*

Ashraf 11/27/2022 2698947782 add data repository index file

*/

import React from 'react';
import AddFieldListForm from './AddDataRepoForm';

const AddDataRepositoryForm = ({
  setTabValue,
  rowSelected,
  isCopyData,
  StepperFieldList,
  setShowSearch,
  handleChange,
  fieldList,
  setFieldList,
  repositoryFields,
}) => {
  return (
    <>
      <AddFieldListForm
        StepperFieldList={StepperFieldList}
        setTabValue={setTabValue}
        rowSelected={rowSelected}
        isCopyData={isCopyData}
        setShowSearch={setShowSearch}
        handleTabChange={handleChange}
        globalFieldList={fieldList}
        setGlobalFieldList={setFieldList}
        repositoryFields={repositoryFields}
      />
    </>
  );
};

export default AddDataRepositoryForm;
